import Yelp_Business_Finder_For_Pittsburgh from './Yelp_Business_Finder_For_Pittsburgh.png'
import bank_failures from './bank_failures.png'
import added_sugar from './added-sugar.png'
import San_Francisco_Street_Tree from './San_Francisco_Street_Tree.png'
import World_2020_GDP from './2020_World_GDP.png'
import yelp_crime from './yelp_crime.png'
import new_york_income from './new_york_income.png'
import color_bar from './color_bar.png'
import senate_roll_call_nodes from './senate_roll_call_nodes.png'
import honor_research from './honor_research.png'
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResponsiveAppBar from './Appbar.tsx';
import { Grid, Card, CardActionArea, CardMedia, Typography, styled } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ArrowLink from './ClickToNextPage';

const theme = createTheme();
// ...

const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth: 345,
  position: 'relative',
  overflow: 'hidden',
  margin: theme.spacing(2),
}));

const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  height: 200,
  transition: 'opacity 0.3s',
  '&:hover': {
    opacity: 0.5,
  },
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: 'rgba(0, 0, 0, 0.5)',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  color: 'white',
  textAlign: 'center',
  opacity: 0,
  transition: 'opacity 0.3s',
  '&:hover': {
    opacity: 1,
  },
}));

// ...


const projects = [
  {
    title: 'Added Sugar Visualization',
    img: added_sugar,
    link: 'https://tialikerice.github.io/added-sugar-visualization/',
  },
  {
    title: 'Bank Failures 2023',
    img: bank_failures,
    link: 'https://tialikerice.github.io/Bank_Failures/',
  },
  {
    title: 'Yelp Business Finder For Pittsburgh',
    img: Yelp_Business_Finder_For_Pittsburgh,
    link: 'https://tialikerice.github.io/yelp_pittsburgh.csv/',
  },
  {
    title: ' San Francisco Street Tree Data Visualization',
    img: San_Francisco_Street_Tree,
    link: 'https://tialikerice.github.io/5311HW1TianchenWang/',
  },
  {
    title: '2020 World GDP Data Visualization',
    img: World_2020_GDP,
    link: 'https://tialikerice.github.io/World_GDP_Data/',
  },
  {
    title: 'Crime Business Pattern Investigation Philadelphia',
    img: yelp_crime,
    link: 'https://tialikerice.github.io/Crime_Business_Pattern_Investigation_Philadelphia/',
  },
  {
    title: 'New York State Income Distribution',
    img: new_york_income,
    link: 'https://tialikerice.github.io/New_York_State_Income_Map/',
  },
  {
    title: 'Color Bar',
    img: color_bar,
    link: 'https://tialikerice.github.io/color_bar/',
  },
  {
    title: 'senate roll call nodes',
    img: senate_roll_call_nodes,
    link: 'https://tialikerice.github.io/senate_roll_call_nodes/',
  },

  // ... other projects
];

const honorResearch = [
  {
    title: 'Independent Study: A graphical Exploration of ISU Police Crime Logs',
    img: honor_research, // 请替换为您的图像链接
    link: '#/ISUResearchPage',
  },
];


const WorkSample = () => {
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={theme}>
      <>
        <div className="App">
          <ResponsiveAppBar worksample="bold" />
          <br />
          <br />
          <br />
          <h1> Work Sample</h1>
        </div>
        <h2 style={{marginLeft: '10%', marginRight: '10%'}}> - HTML / JavaScript / D3.js Project:</h2>
        <Grid container spacing={2} style={{ padding: '2rem 5rem' }}>
          {projects.map((project, idx) => (
            <Grid item key={idx} xs={12} sm={6} md={4} lg={3}>
              <StyledCard>
                <CardActionArea onClick={() => window.location.href = project.link}>
                  <StyledCardMedia
                    image={project.img}
                    title={project.title}
                  />
                  <StyledTypography variant="h6">{project.title}</StyledTypography>
                </CardActionArea>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
        <h2 style={{marginLeft: '10%', marginRight: '10%'}}> - Honor Research:</h2>
        <Grid container spacing={2} style={{ padding: '2rem 5rem' }}>
  {honorResearch.map((project, idx) => (
    <Grid item key={idx} xs={12} sm={6} md={4} lg={3}>
      <StyledCard>
        <CardActionArea onClick={() => window.location.href = project.link}>
          <StyledCardMedia
            image={project.img}
            title={project.title}
          />
          <StyledTypography variant="h6">{project.title}</StyledTypography>
        </CardActionArea>
      </StyledCard>
    </Grid>
  ))}
</Grid>
<div style={{ width: '100%', position: 'fixed', bottom: '0' }}>
    <ArrowLink
  to="/mytimeline"
  onClick={() => navigate("/mytimeline")}
  label="Click to My Journey"
/>
    </div>
      </>
    </ThemeProvider>
  );
};

export default WorkSample;
